import React, {useRef, useState} from "react";
import { useScroll } from 'react-use-gesture';
import { useSpring, animated } from 'react-spring';
import {Link} from "react-router-dom";
import './landingPage.scss';

import Button from "../../components/Button";
import Modal from "../../components/Modal";
import Input from '../../components/Input';
import {PostCall} from '../../utils/connection';

import Logo from './logo_ACADEMONS@2x.png';
import ByImg from './BY_CEREBRITI@2x.png';
import Icon from './gif-animado@3x.png';

import Checkbox from "../../components/Checkbox";
import CheckboxGroup from "../../components/CheckboxGroup";
import Select from "../../components/Select";

const baseValues = {value: '', error: true}

const LandingPage = ({descImg, points, titleSecondary, poster, form, text}) => {
    const blankUserInfo = {...Object.fromEntries(form.map(({name, value, type}) => ([name, {value: value || '', error: type !== 'hidden'}]))), terms: {value: false, error: true}, userType: {value: false, error: true}};
    const [scrolled, setScrolled] = useState(false);
    const [show, setShow] = useState(false);
    const [download, setDownload] = useState(false);
    const [email, setEmail] = useState(blankUserInfo.email)
    const [schoolYear, setSchoolYear] = useState(blankUserInfo.schoolYear)
    const [userType, setUserType] = useState(blankUserInfo.userType)
    const [terms, setTerms] = useState(blankUserInfo.terms)
    const [validate, setValidate] = useState(false);

    const props = useSpring({
        background: scrolled ? '#007c90' :'#019BB5',
    })
    useScroll(({ xy: [, y] }) => {
        setScrolled(y > 0);
    }, {
        domTarget: window,
    })

    const [contactName, setContactName] = useState(baseValues);
    const [contactEmail, setContactEmail] = useState(baseValues);
    const [desc, setDesc] = useState(baseValues);
    const [validateContactInfo, setValidateContactInfo] = useState(false);

    const targetElement = useRef(null);

    const scrollToTarget = () => {
        const element = targetElement.current;
        const value = window.scrollY + element.getBoundingClientRect().top;

        window.scroll(0, value);
    }

    const downloadPdf = () => {
        const pdfs = {
            'Cuaderno de 1º Primaria': 'https://res.cloudinary.com/cerebriti/image/upload/v1622802412/DESCARGAS%20PDF%20CUADERNOS%20VACACIONES/cuaderno_ACADEMONS_1Primaria.pdf',
            'Cuaderno de 2º Primaria': 'https://res.cloudinary.com/cerebriti/image/upload/v1622802416/DESCARGAS%20PDF%20CUADERNOS%20VACACIONES/cuaderno_ACADEMONS_2Primaria.pdf',
            'Cuaderno de 3º Primaria': 'https://res.cloudinary.com/cerebriti/image/upload/v1622802421/DESCARGAS%20PDF%20CUADERNOS%20VACACIONES/cuaderno_ACADEMONS_3Primaria.pdf',
            'Cuaderno de 4º Primaria': 'https://res.cloudinary.com/cerebriti/image/upload/v1622802427/DESCARGAS%20PDF%20CUADERNOS%20VACACIONES/cuaderno_ACADEMONS_4Primaria.pdf',
            'Cuaderno de 5º Primaria': 'https://res.cloudinary.com/cerebriti/image/upload/v1622802431/DESCARGAS%20PDF%20CUADERNOS%20VACACIONES/cuaderno_ACADEMONS_5Primaria.pdf',
            'Cuaderno de 6º Primaria': 'https://res.cloudinary.com/cerebriti/image/upload/v1622802439/DESCARGAS%20PDF%20CUADERNOS%20VACACIONES/cuaderno_ACADEMONS_6Primaria.pdf'
        }
        window.open(pdfs[schoolYear.value]);
        setDownload(false);
    }

    const postContact = () => {
        setValidateContactInfo(true);
        if (!(contactName.error || contactEmail.error || desc.error)) {
            PostCall({path: 'cuadernos-vacaciones/contacto', data: {
                    txtNombre: contactName.value,
                    txtEmail: contactEmail.value,
                    txtMensaje: desc.value
                }}).then(res => {
                const {success} = res;
                if (success) {
                    setShow(false);
                    setContactEmail(baseValues);
                    setDesc(baseValues);
                    setContactName(baseValues);
                }
            })
        }
    }

    const onFinish = () => {
        setValidate(true);
        if (!(email.error || schoolYear.error || userType.error || terms.error)) {
            PostCall({path: 'cuadernos-vacaciones/alta', data: {
                    email: email.value,
                    schoolYear: schoolYear.value,
                    userType: userType.value
                }}).then(res => {
                const {success} = res;
                if (success) {
                    setDownload(true);
                }
            })
        }
    }

    return (<div className={'landing-page-main'}>
        <animated.div className={`header`} style={props}>
            <div className={'logo'}>
                <Link to={'/cuaderno-de-vacaciones'}>
                    <img src={Logo} alt={'logo'}/>
                    <img src={ByImg} alt={'by'}/>
                </Link>
            </div>
            <div className={'download'}/>
        </animated.div>
        <div className={'banner-container'}>
            <div>
                <div className={'cover-img-container'}>
                    <div>
                        <img src={poster} alt={'poster'} />
                    </div>
                </div>
                <div className={'form-container'} >
                    <h4>
                        <b>
                            ACTIVIDADES DE REPASO PARA NIÑOS DE PRIMARIA
                        </b>
                    </h4>
                    <h1 className={'title'}>¡Descarga tu cuaderno de vacaciones gratis!</h1>
                    <p ref={targetElement}>
                        {text}
                    </p>
                    <form>
                        <CheckboxGroup
                            name={'userType'}
                            onChange={(e, v) => setUserType({value: e, error: v})}
                            value={userType.value}
                            validate={validate}
                            fields={[
                                {value: 'padre', name: 'Soy padre/madre'},
                                {value: 'docente', name: 'Soy docente'}
                            ]}
                        />
                        {
                            blankUserInfo.schoolYear.error &&
                            <Select
                                name={'schoolYear'}
                                value={schoolYear.value}
                                onChange={(e, v) => setSchoolYear({value: e, error: v})}
                                validate={validate}
                                label={'Elige un curso'}
                                options={form[0].options}
                            />
                        }
                        <Input
                            name={'email'}
                            label={'Escribe tu email'}
                            value={email.value}
                            onChange={(e, v) => setEmail({value: e, error: v})}
                            validate={validate}
                            type={'email'}
                        />
                        <Checkbox
                            value={terms.value}
                            onChange={(e, v) => setTerms({value: e, error: v})}
                            validate={validate}
                            label={<>
                                Acepto la <a href="https://www.academons.com/privacidad" target="_blank" rel="noopener noreferrer"> Política de
                                Privacidad</a> y <a href="https://www.academons.com/bbll" target="_blank"
                                                    rel="noopener noreferrer">Términos de uso</a>
                            </>}
                            name={'agree'}
                        />
                        <Button type={'primary'} onClick={onFinish}>¡ENVÍAMELO GRATIS!</Button>
                        <p className="small-text">Al introducir tus datos aceptas darte de alta en nuestro boletín
                            educativo, en el que te informaremos de más descargables y otras noticias de Academons.</p>
                    </form>
                </div>
            </div>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
                <path fill="#fff" fillOpacity="1" d="M0,224L80,197.3C160,171,320,117,480,128C640,139,800,213,960,240C1120,267,1280,245,1360,234.7L1440,224L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z"/>
            </svg>
        </div>

        <div className={'description-container'}>
            <h1 className={'title-secondary'}>{titleSecondary}</h1>
            <div className={'content'}>
                <div className={'points'}>
                    <ul>
                        {
                            points.map((item, i) => <li key={i}>
                                {item}
                            </li>)
                        }
                    </ul>
                </div>
                <div className={'poster'}>
                    <img src={descImg} alt={'desc'} />
                </div>
                <div>
                    <div>
                        <Button
                            type={'primary'}
                            onClick={scrollToTarget}
                            href="#up"
                        >
                            DESCARGA EL CUADERNO
                        </Button>
                    </div>
                </div>
            </div>
        </div>

        {/*<div className={'description-container'} style={{background: 'rgb(0, 124, 144)'}}>*/}
        {/*    <h1 className={'title-secondary'} style={{color: 'white'}}>{titleSecondary}</h1>*/}
        {/*    <div className={'content'} style={{flexDirection: 'row-reverse'}}>*/}
        {/*        <div className={'points'}>*/}
        {/*            <ul>*/}
        {/*                {*/}
        {/*                    points.map((item, i) => <li key={i} style={{color: 'white'}}>*/}
        {/*                        {item}*/}
        {/*                    </li>)*/}
        {/*                }*/}
        {/*            </ul>*/}
        {/*        </div>*/}
        {/*        <div className={'poster'}>*/}
        {/*            <img src={descImg} alt={'desc'} />*/}
        {/*        </div>*/}
        {/*        <div>*/}
        {/*            <div>*/}
        {/*                <Button*/}
        {/*                    type={'primary'}*/}
        {/*                    onClick={scrollToTarget}*/}
        {/*                    href="#up"*/}
        {/*                >*/}
        {/*                    DESCARGA EL CUADERNO*/}
        {/*                </Button>*/}
        {/*            </div>*/}
        {/*        </div>*/}
        {/*    </div>*/}
        {/*</div>*/}

        {/*<div className={'description-container'}>*/}
        {/*    <h1 className={'title-secondary'}>{titleSecondary}</h1>*/}
        {/*    <div className={'content'}>*/}
        {/*        <div className={'points'}>*/}
        {/*            <ul>*/}
        {/*                {*/}
        {/*                    points.map((item, i) => <li key={i}>*/}
        {/*                        {item}*/}
        {/*                    </li>)*/}
        {/*                }*/}
        {/*            </ul>*/}
        {/*        </div>*/}
        {/*        <div className={'poster'}>*/}
        {/*            <img src={descImg} alt={'desc'} />*/}
        {/*        </div>*/}
        {/*        <div>*/}
        {/*            <div>*/}
        {/*                <Button*/}
        {/*                    type={'primary'}*/}
        {/*                    onClick={scrollToTarget}*/}
        {/*                    href="#up"*/}
        {/*                >*/}
        {/*                    DESCARGA EL CUADERNO*/}
        {/*                </Button>*/}
        {/*            </div>*/}
        {/*        </div>*/}
        {/*    </div>*/}
        {/*</div>*/}

        <div className={'footer'}>
            <div className={'social-area'}>
                <div>
                    <div>
                        <img src={Logo} alt={'logo'}/>
                    </div>
                    <div>
                        <img src={ByImg} alt={'by'}/>
                    </div>
                    <div className={'social-icons'}>
                        <a href="https://www.facebook.com/Academons" target={'_blank'} rel="noopener noreferrer">
                            <i className="fab fa-facebook-f" />
                        </a>
                        <a href="http://www.twitter.com/Academons" target={'_blank'} rel="noopener noreferrer">
                            <i className="fab fa-twitter" />
                        </a>
                        <a href="http://www.instagram.com/Academons" target={'_blank'} rel="noopener noreferrer">
                            <i className="fab fa-instagram" />
                        </a>
                    </div>
                </div>
                <div>
                    <Button type={'text'} onClick={() => setShow(true)}>
                        ¿Tienes alguna duda?
                    </Button>
                    <Button type={'button'} onClick={() => setShow(true)}>
                        Contacta con nosotros
                    </Button>
                </div>
            </div>
            <div>
                <div>
                    <ul>
                        <li>
                            <a href={'https://www.academons.com/app-juegos-1-primaria'}>Actividades de 1º Primaria</a>
                        </li>
                        <li>
                            <a href={'https://www.academons.com/app-juegos-2-primaria'}>Actividades de 2º Primaria</a>
                        </li>
                        <li>
                            <a href={'https://www.academons.com/app-juegos-3-primaria'}>Actividades de 3º Primaria</a>
                        </li>
                        <li>
                            <a href={'https://www.academons.com/app-juegos-4-primaria'}>Actividades de 4º Primaria</a>
                        </li>
                        <li>
                            <a href={'https://www.academons.com/app-juegos-5-primaria'}>Actividades de 5º Primaria</a>
                        </li>
                        <li>
                            <a href={'https://www.academons.com/app-juegos-6-primaria'}>Actividades de 6º Primaria</a>
                        </li>
                    </ul>
                </div>

                <div>
                    <ul>
                        <li>
                            <a href={'https://www.academons.com/app-lengua-primaria'}>Juegos Lengua Primaria</a>
                        </li>
                        <li>
                            <a href={'https://www.academons.com/app-matematicas-primaria'}>Juegos Matemáticas Primaria</a>
                        </li>
                        <li>
                            <a href={'https://www.academons.com/app-ingles-primaria'}>Juegos Inglés Primaria</a>
                        </li>
                        <li>
                            <a href={'https://www.academons.com/app-ciencias-naturales-primaria'}>Juegos Ciencias Naturales Primaria</a>
                        </li>
                        <li>
                            <a href={'https://www.academons.com/app-ciencias-sociales-primaria'}>Juegos Ciencias Sociales Primaria</a>
                        </li>
                        <li>
                            <a href={'https://www.academons.com/cuaderno-de-vacaciones/'}>Cuadernos de vacaciones gratis</a>
                        </li>
                    </ul>
                </div>

                <div>
                    <ul>
                        <li>
                            <a href={'https://www.academons.com/profesores'}>App para maestros Primaria</a>
                        </li>
                        <li>
                            <a href={'https://www.academons.com/aplicacion-repaso-primaria'}>App para repasar Primaria</a>
                        </li>
                        <li>
                            <a href={'https://www.academons.com/app-home-school'}>App de homeschooling</a>
                        </li>
                        <li>
                            <a href={'https://www.academons.com/ejercicios-verano-primaria'}>App de repaso de verano</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <Modal
            title={'Contacta con nosotros'}
            show={show}
            close={setShow}
        >
            <form>
                <Input
                    name={'name'}
                    label={'Tu nombre y apellidos'}
                    value={contactName.value}
                    onChange={(value, error) => setContactName({value, error})}
                    validate={validateContactInfo}
                />
                <Input
                    name={'email'}
                    label={'Tu dirección de correo electrónico'}
                    value={contactEmail.value}
                    onChange={(value, error) => setContactEmail({value, error})}
                    validate={validateContactInfo}
                    type={'email'}
                />
                <Input
                    name={'desc'}
                    label={'¿En qué te podemos ayudar?'}
                    value={desc.value}
                    onChange={(value, error) => setDesc({value, error})}
                    validate={validateContactInfo}
                    type={'textarea'}
                />
                <Button type={'primary'} onClick={postContact}>
                    Contactar
                </Button>
            </form>
        </Modal>

        <Modal
            show={download}
            close={setDownload}
        >
            <div className={'download-popup-main'}>
                <img src={Icon} alt={'icon'} />
                <h3>¡Descarga aquí tu cuaderno de vacaciones!</h3>

                <Button className={'button-main--download'} onClick={downloadPdf}>
                    Descarga
                </Button>
            </div>
        </Modal>
    </div>)
};

export default LandingPage;